// 0：未订购视频彩铃包月或渠道视频彩铃包；
// 1：已订购视频彩铃订阅包
// 2：已订购渠道视频彩铃包；
// 3：已订购视频彩铃订阅包和渠道视频彩铃包。
export var MonthStatusDic;
(function (MonthStatusDic) {
    MonthStatusDic["UnsubscribedAndChannel"] = "0";
    MonthStatusDic["Subscribed"] = "1";
    MonthStatusDic["SubscribedChannel"] = "2";
    MonthStatusDic["SubscribedAndChannel"] = "3";
})(MonthStatusDic || (MonthStatusDic = {}));
// 实现支付类型对象
export const MonthStatusType = {
    ENUM: {
        [MonthStatusDic.UnsubscribedAndChannel]: '0：未订购视频彩铃包月或渠道视频彩铃包；',
        [MonthStatusDic.Subscribed]: '1：已订购视频彩铃订阅包',
        [MonthStatusDic.SubscribedChannel]: '2：已订购渠道视频彩铃包',
        [MonthStatusDic.SubscribedAndChannel]: '3：已订购视频彩铃订阅包和渠道视频彩铃包'
    },
    UnsubscribedAndChannel: MonthStatusDic.UnsubscribedAndChannel,
    Subscribed: MonthStatusDic.Subscribed,
    SubscribedChannel: MonthStatusDic.SubscribedChannel,
    SubscribedAndChannel: MonthStatusDic.SubscribedAndChannel
};
